var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail",
    clipPath: "url(#clip0_86_247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.57728 5.44891H30.8283C32.2893 5.44891 33.4847 6.64428 33.4847 8.10529V24.0436C33.4847 25.5046 32.2893 26.7 30.8283 26.7H9.57728C8.11627 26.7 6.9209 25.5046 6.9209 24.0436V8.10529C6.9209 6.64428 8.11627 5.44891 9.57728 5.44891Z",
    stroke: "#959595",
    strokeWidth: 2.65638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.4847 7L20.2028 16.2973L6.9209 7",
    stroke: "#959595",
    strokeWidth: 2.65638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8766,
    height: 31.8766,
    fill: "white",
    transform: "translate(0.264648 0.135925)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3d8ac685bd688f644814ac05a9d71003.svg";
export { ForwardRef as ReactComponent };